import {
  EymemoriesStageSteps,
  GenericResponse,
  Observation,
  ValidateOrderResponse,
} from "src/shared/types/src";
import { getAxiosInstance } from "../api";
import { PDF_BOOK_PAGE_SIZE } from "src/shared/config/src/lib/constants";

export const validateOrder = async ({
  dob,
  email,
  orderHash,
  captchaToken,
  callback,
}: {
  dob: string;
  email: string;
  orderHash: string;
  captchaToken: string;
  callback: (response: GenericResponse<ValidateOrderResponse>) => void;
}): Promise<any> => {
  const { eymemoriesAxios } = getAxiosInstance();
  const res = await eymemoriesAxios.post(`/eymemories/validate`, {
    dob,
    email,
    hash: orderHash,
    captchaToken,
  });

  const response = res.data;
  if (response && response.status === "success") {
    return callback(response);
  }
};

export const trackOrderStatus = async ({
  status,
  callback,
  orderHash,
}: {
  status: EymemoriesStageSteps;
  orderHash: string;
  callback?: (response: GenericResponse<any>) => void;
}) => {
  try {
    const { eymemoriesAxios } = getAxiosInstance();
    const res = await eymemoriesAxios.patch(
      `/eymemories/track`,
      {
        event: status,
      },
      {headers: {orderHash}}
    );

    const response = res.data;
    if (response && response.status === "success") {
      return callback?.(response);
    }
  } catch (e) {
    console.error(`track order status failed for status = ${status}`);
  }
};
